module.exports = __webpack_public_path__ + "img/check-azul-1.65443a55.svg";